import clsx from 'clsx';
import { Filter } from '../interface';
import { Icon } from '../../icon/Icon';
import styles from './FiltersPopper.module.scss';

interface FilterRenderOptionProps extends React.HTMLAttributes<HTMLLIElement> {
  option: Filter;
  filterCount: number;
}

export function FilterRenderOption({ option, filterCount, ...props }: FilterRenderOptionProps) {
  const { title, icon, filterKey } = option;

  return (
    <li {...props} className={clsx(styles.filterRenderOption, props?.className)} id={filterKey}>
      {icon ? <Icon dataId={`${filterKey}-${icon}-icon`} name={icon} size={4} /> : null}
      <p className='text-body-1 ml-1'> {title}</p>
      {filterCount > 0 ? (
        <p
          data-id={`${filterKey}-filter-count`}
          className={clsx(styles.filterCount, ' text-caption-2 text-secondary')}
        >
          {filterCount}
        </p>
      ) : null}
      <Icon dataId={`${filterKey}-right-arrow`} className={styles.rightArrow} name='right-arrow' />
    </li>
  );
}
